import { FunctionComponent, ReactElement, useCallback } from "react";
import { Amount } from "../../../../../../components";
import { colors } from "../../../../../../styles/colors";
import { Icon } from "../../../../../../ui";
import styles from "./IncomeSource.module.scss";
import { IIncomeSourceProps } from "./types";

export const IncomeSource: FunctionComponent<IIncomeSourceProps> = (
  props: IIncomeSourceProps
): ReactElement<IIncomeSourceProps> => {
  const { incomeSource, onPress, ...restProps } = props;

  const doPress = useCallback(() => {
    onPress(incomeSource);
  }, [incomeSource, onPress]);

  return (
    <div className="col-lg-3 cardCol" {...restProps}>
      <div className="card smallCard mainBlockBg" onClick={doPress}>
        <Icon
          backgroundColor={incomeSource.color}
          className={styles.iconDefault}
          color={colors.palette.white}
          icon={incomeSource.icon}
          size={32}
        />
        <div className="cardContent">
          <Amount
            className="cardContentValue"
            currency={incomeSource.currency}
            value={incomeSource.balance}
          />
          <span className="cardContentLabel">{incomeSource.name}</span>
        </div>
      </div>
    </div>
  );
};
